// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variation 5 - Professional Corporate Design System */

/* Reset and Base Styles */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    color: #333;
    background-color: #000042;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
    font-family: Georgia, serif;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 0.5em;
}

h1 { font-size: 2.5rem; color: #000042; }
h2 { font-size: 2.2rem; color: #000042; }
h3 { font-size: 1.8rem; color: #000042; }
h4 { font-size: 1.4rem; color: #000042; }
h5 { font-size: 1.2rem; color: #000042; }
h6 { font-size: 1rem; color: #000042; }

p {
    margin-bottom: 1em;
    line-height: 1.7;
}

/* Buttons */
.btn-primary, .btn-secondary, .btn-outline {
    display: inline-block;
    padding: 12px 24px;
    border-radius: 25px;
    text-decoration: none;
    font-weight: 600;
    text-align: center;
    border: 2px solid transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 16px;
}

.btn-primary {
    background-color: #000042 !important;
    color: white !important;
    border-color: #000042 !important;
}

.btn-primary:hover {
    background-color: #004080 !important;
    border-color: #004080 !important;
    transform: translateY(-1px);
}

/* Enhanced CTA Buttons for Demo - More Visible */
.btn-cta, .btn-demo {
    display: inline-block;
    background:
        radial-gradient(circle at 20% 50%, #FFD700 0%, transparent 50%),
        radial-gradient(circle at 80% 50%, #DAA520 0%, transparent 50%),
        linear-gradient(135deg, #B8860B, #DAA520, #FFD700);
    background-size: 200% 100%, 200% 100%, 100% 100%;
    color: white !important;
    border: 1px solid rgba(184, 134, 11, 0.8);
    padding: 16px 36px;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    border-radius: 25px;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow:
        0 0 35px rgba(255, 215, 0, 0.5),
        inset 0 2px 8px rgba(255, 255, 255, 0.3);
    animation:
        elegant-wave 5s ease-in-out infinite,
        wave-glow 2.5s ease-in-out infinite alternate;
    text-shadow: 0 1px 1px rgba(255,255,255,0.3);
}

/* Registration form specific button styling */
.form-actions .btn-cta,
button[type="submit"].btn-cta {
    color: white !important;
}

.btn-cta:hover, .btn-demo:hover {
    background-size: 300% 100%, 300% 100%, 100% 100%;
    transform: translateY(-3px) scale(1.05);
    box-shadow:
        0 0 50px rgba(255, 215, 0, 0.7),
        inset 0 2px 8px rgba(255, 255, 255, 0.4);
    color: white !important;
}

@keyframes pulse {
    0%, 100% {
        box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);
        transform: translateY(0);
    }
    50% {
        box-shadow: 0 4px 30px rgba(255, 107, 53, 0.6);
        transform: translateY(-2px);
    }
}

.btn-secondary {
    background-color: transparent !important;
    color: #000042 !important;
    border-color: #000042 !important;
}

.btn-secondary:hover {
    background-color: #000042 !important;
    color: white !important;
    border-color: #000042 !important;
}

.btn-outline {
    background-color: transparent;
    color: #000042;
    border-color: #000042;
}

.btn-outline:hover {
    background-color: #000042;
    color: white;
}

/* White border for outline buttons on dark backgrounds */
.btn-outline[style*="color: white"] {
    border-color: white !important;
    color: white !important;
}

.btn-outline[style*="color: white"]:hover {
    background-color: white !important;
    color: #000042 !important;
    border-color: white !important;
}

/* Header */
.header {
    background-color: white;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    transition: all 0.3s ease;
}

.header .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
}

.nav-brand .logo {
    color: #000042;
    font-size: 1.8rem;
    margin-bottom: 0;
    font-family: Georgia, serif;
}

.nav-brand .tagline {
    color: #666;
    font-size: 0.9rem;
    margin-bottom: 0;
    font-style: italic;
}

.nav-menu ul {
    display: flex;
    list-style: none;
    align-items: center;
    gap: 30px;
}

.nav-menu a {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    transition: color 0.3s ease;
}

.nav-menu a:hover {
    color: #000042;
}

/* Hero Section */
.hero {
    background: #000042;
    color: white;
    padding: 120px 0 80px;
    margin-top: 80px;
}

.hero-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
}

.hero-title {
    font-size: 3rem;
    margin-bottom: 20px;
    color: white;
}

.hero-subtitle {
    font-size: 1.3rem;
    margin-bottom: 30px;
    opacity: 0.9;
    line-height: 1.6;
}

.hero-stats {
    display: flex;
    gap: 40px;
    margin-bottom: 40px;
    padding: 20px 0;
    border-top: 1px solid rgba(255,255,255,0.2);
    border-bottom: 1px solid rgba(255,255,255,0.2);
}

.stat-item {
    text-align: center;
}

.stat-number {
    display: block;
    font-size: 2.5rem;
    font-weight: bold;
    color: #fff;
    font-family: Georgia, serif;
}

.stat-label {
    display: block;
    font-size: 0.9rem;
    opacity: 0.8;
    margin-top: 5px;
}

/* Trust Section */
.trust-section {
    background-color: white;
    padding: 40px 0;
    border-bottom: 1px solid #e9ecef;
}

.trust-badges {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 30px;
}

.badge, .trust-badge {
    background-color: #f8f9fa;
    padding: 10px 20px;
    border-radius: 25px;
    border: 2px solid #e9ecef;
    font-weight: 600;
    color: #666;
    font-size: 0.9rem;
}

/* Services Section */
.services {
    padding: 80px 0;
    background-color: white;
}

.section-header {
    text-align: center;
    margin-bottom: 60px;
}

.section-title {
    color: #000042;
    margin-bottom: 15px;
}

.section-subtitle {
    color: #666;
    font-size: 1.2rem;
    max-width: 600px;
    margin: 0 auto;
}

.services-grid, .grid {
    display: grid;
    gap: 30px;
}

.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }
.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }
.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }

.service-card, .card {
    background-color: #f8f9fa;
    padding: 40px 30px;
    border-radius: 25px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
}

.service-card:hover, .card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    border-color: #000042;
}

.service-icon {
    font-size: 3rem;
    margin-bottom: 20px;
}

.service-card h4, .card h4 {
    color: #000042;
    margin-bottom: 15px;
}

.service-card p, .card p {
    color: #666;
    margin-bottom: 20px;
}

.service-features {
    list-style: none;
    text-align: left;
}

.service-features li {
    padding: 8px 0;
    color: #555;
    position: relative;
    padding-left: 20px;
}

.service-features li:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #000042;
    font-weight: bold;
}

/* Features Section */
.features {
    padding: 80px 0;
    background-color: #f8f9fa;
}

.features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 40px;
}

.feature-item {
    background-color: white;
    padding: 40px 30px;
    border-radius: 25px;
    text-align: center;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
}

.feature-item:hover {
    box-shadow: 0 8px 20px rgba(0,0,0,0.1);
    transform: translateY(-3px);
}

.feature-icon {
    font-size: 3rem;
    margin-bottom: 20px;
}

.feature-item h4 {
    color: #000042;
    margin-bottom: 15px;
}

.feature-item p {
    color: #666;
}

/* Pricing Section */
.pricing {
    padding: 80px 0;
    background-color: white;
}

.pricing-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    margin-top: 50px;
}

.pricing-card {
    background-color: #f8f9fa;
    border: 2px solid #e9ecef;
    border-radius: 25px;
    padding: 40px 30px;
    text-align: center;
    position: relative;
    transition: all 0.3s ease;
}

.pricing-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.pricing-card.featured {
    border-color: #000042;
    background-color: white;
    transform: scale(1.05);
}

.popular-badge {
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #000042;
    color: white;
    padding: 8px 20px;
    border-radius: 25px;
    font-size: 0.9rem;
    font-weight: 600;
}

.price {
    font-size: 3rem;
    font-weight: bold;
    color: #000042;
    font-family: Georgia, serif;
}

.period {
    font-size: 1.2rem;
    color: #666;
}

/* Forms */
.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
    color: #333;
}

.form-control, input[type="text"], input[type="email"], input[type="tel"],
input[type="password"], input[type="number"], textarea, select {
    width: 100%;
    padding: 12px;
    border: 2px solid #e9ecef;
    border-radius: 25px;
    font-size: 16px;
    color: #000000;
    transition: border-color 0.3s ease;
}

.form-control:focus, input:focus, textarea:focus, select:focus {
    outline: none;
    border-color: #000042;
}

/* Footer */
.footer {
    background-color: #000042;
    color: white;
    padding: 60px 0 20px;
}

.footer-content {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 40px;
    margin-bottom: 40px;
}

.footer-brand h4 {
    color: white;
    margin-bottom: 15px;
}

.footer-brand p {
    opacity: 0.8;
    line-height: 1.6;
}

.footer-section h5 {
    color: white;
    margin-bottom: 20px;
    font-size: 1.1rem;
}

.footer-section ul {
    list-style: none;
}

.footer-section li {
    margin-bottom: 10px;
}

.footer-section a {
    color: rgba(255,255,255,0.8);
    text-decoration: none;
    transition: color 0.3s ease;
}

.footer-section a:hover {
    color: white;
}

/* Lithuanian Text Fixes */
.lithuanian-heading {
    font-family: Georgia, serif;
    color: #000042;
    letter-spacing: -0.5px;
}

.lithuanian-text {
    line-height: 1.7;
    color: #333;
}

/* Admin Dashboard */
.admin-header {
    background: #000042;
    color: white;
    padding: 2rem 0;
}

.dashboard-card {
    background: white;
    border-radius: 25px;
    padding: 2rem;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    margin-bottom: 2rem;
}

.stat-card {
    background: #000042;
    color: white;
    padding: 2rem;
    border-radius: 25px;
    text-align: center;
}

/* Utility Classes */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

.mt-1 { margin-top: 0.5rem; }
.mt-2 { margin-top: 1rem; }
.mt-3 { margin-top: 2rem; }
.mt-4 { margin-top: 3rem; }

.mb-1 { margin-bottom: 0.5rem; }
.mb-2 { margin-bottom: 1rem; }
.mb-3 { margin-bottom: 2rem; }
.mb-4 { margin-bottom: 3rem; }

.p-1 { padding: 0.5rem; }
.p-2 { padding: 1rem; }
.p-3 { padding: 2rem; }
.p-4 { padding: 3rem; }

/* Responsive Design */
@media (max-width: 768px) {
    .container {
        padding: 0 15px;
    }

    .header .container {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .mobile-menu-toggle {
        display: block !important;
    }

    .nav-menu {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background: white;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 1000;
    }

    .nav-menu-open {
        display: block !important;
    }

    .nav-menu ul {
        flex-direction: column;
        padding: 1rem 0;
        margin: 0;
        gap: 0;
    }

    .nav-menu li {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #f0f0f0;
    }

    .nav-menu li:last-child {
        border-bottom: none;
    }

    .nav-menu a {
        display: block;
        padding: 1rem;
        width: 100%;
        text-decoration: none;
        transition: background-color 0.3s ease;
    }

    .nav-menu a:hover {
        background-color: #f8f9fa;
    }

    .nav-menu .btn-secondary,
    .nav-menu .btn-primary {
        margin: 0.5rem 1rem;
        border-radius: 25px;
        font-weight: 600;
    }

    .nav-menu .btn-secondary {
        background: #f8f9fa;
        color: #000042;
        border: 2px solid #000042;
    }

    .nav-menu .btn-primary {
        background: #000042;
        color: white;
        border: 2px solid #000042;
    }

    .hero-content {
        grid-template-columns: 1fr;
        gap: 40px;
        text-align: center;
    }

    .hero-title {
        font-size: 2.2rem;
    }

    .grid-cols-2, .grid-cols-3, .grid-cols-4 {
        grid-template-columns: 1fr;
    }

    .footer-content {
        grid-template-columns: 1fr;
        gap: 30px;
        text-align: center;
    }

    .btn-cta, .btn-demo {
        width: 100%;
        padding: 16px;
    }
}

/* Loading States */
.loading {
    opacity: 0.7;
    pointer-events: none;
}

.spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid #e9ecef;
    border-top-color: #000042;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* Smooth scrolling */
html {
    scroll-behavior: smooth;
}


@keyframes elegant-wave {
  0% { background-position: 0% 50%, 100% 50%, 0% 50%; }
  50% { background-position: 100% 50%, 0% 50%, 0% 50%; }
  100% { background-position: 0% 50%, 100% 50%, 0% 50%; }
}

@keyframes wave-glow {
  0% { box-shadow: 0 0 35px rgba(255, 215, 0, 0.5), inset 0 2px 8px rgba(255, 255, 255, 0.3); }
  100% { box-shadow: 0 0 50px rgba(255, 215, 0, 0.7), inset 0 2px 8px rgba(255, 255, 255, 0.4); }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD,0BAA0B;AAC1B;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,KAAK,iBAAiB,EAAE,cAAc,EAAE;AACxC,KAAK,iBAAiB,EAAE,cAAc,EAAE;AACxC,KAAK,iBAAiB,EAAE,cAAc,EAAE;AACxC,KAAK,iBAAiB,EAAE,cAAc,EAAE;AACxC,KAAK,iBAAiB,EAAE,cAAc,EAAE;AACxC,KAAK,eAAe,EAAE,cAAc,EAAE;;AAEtC;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA,iDAAiD;AACjD;IACI,qBAAqB;IACrB;;;0DAGsD;IACtD,gDAAgD;IAChD,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB;;gDAE4C;IAC5C;;qDAEiD;IACjD,4CAA4C;AAChD;;AAEA,8CAA8C;AAC9C;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;IAChD,uCAAuC;IACvC;;gDAE4C;IAC5C,uBAAuB;AAC3B;;AAEA;IACI;QACI,8CAA8C;QAC9C,wBAAwB;IAC5B;IACA;QACI,8CAA8C;QAC9C,2BAA2B;IAC/B;AACJ;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,yDAAyD;AACzD;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA,WAAW;AACX;IACI,uBAAuB;IACvB,sCAAsC;IACtC,eAAe;IACf,MAAM;IACN,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,eAAe,qCAAqC,EAAE;AACtD,eAAe,qCAAqC,EAAE;AACtD,eAAe,qCAAqC,EAAE;;AAEtD;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA,UAAU;AACV;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,2BAA2B;IAC3B,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,gBAAgB,EAAE;;AAE1B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;;AAE7B,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,OAAO,aAAa,EAAE;AACtB,OAAO,aAAa,EAAE;;AAEtB,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,WAAW;QACX,iBAAiB;QACjB,wCAAwC;QACxC,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,SAAS;QACT,MAAM;IACV;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,gCAAgC;IACpC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,WAAW;QACX,qBAAqB;QACrB,sCAAsC;IAC1C;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,qBAAqB;AACrB;IACI,uBAAuB;AAC3B;;;AAGA;EACE,KAAK,6CAA6C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE,KAAK,qFAAqF,EAAE;EAC5F,OAAO,qFAAqF,EAAE;AAChG","sourcesContent":["/* Variation 5 - Professional Corporate Design System */\n\n/* Reset and Base Styles */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    color: #333;\n    background-color: #000042;\n}\n\n.container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n    font-family: Georgia, serif;\n    font-weight: 700;\n    line-height: 1.3;\n    margin-bottom: 0.5em;\n}\n\nh1 { font-size: 2.5rem; color: #000042; }\nh2 { font-size: 2.2rem; color: #000042; }\nh3 { font-size: 1.8rem; color: #000042; }\nh4 { font-size: 1.4rem; color: #000042; }\nh5 { font-size: 1.2rem; color: #000042; }\nh6 { font-size: 1rem; color: #000042; }\n\np {\n    margin-bottom: 1em;\n    line-height: 1.7;\n}\n\n/* Buttons */\n.btn-primary, .btn-secondary, .btn-outline {\n    display: inline-block;\n    padding: 12px 24px;\n    border-radius: 25px;\n    text-decoration: none;\n    font-weight: 600;\n    text-align: center;\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 16px;\n}\n\n.btn-primary {\n    background-color: #000042 !important;\n    color: white !important;\n    border-color: #000042 !important;\n}\n\n.btn-primary:hover {\n    background-color: #004080 !important;\n    border-color: #004080 !important;\n    transform: translateY(-1px);\n}\n\n/* Enhanced CTA Buttons for Demo - More Visible */\n.btn-cta, .btn-demo {\n    display: inline-block;\n    background:\n        radial-gradient(circle at 20% 50%, #FFD700 0%, transparent 50%),\n        radial-gradient(circle at 80% 50%, #DAA520 0%, transparent 50%),\n        linear-gradient(135deg, #B8860B, #DAA520, #FFD700);\n    background-size: 200% 100%, 200% 100%, 100% 100%;\n    color: white !important;\n    border: 1px solid rgba(184, 134, 11, 0.8);\n    padding: 16px 36px;\n    font-size: 18px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    border-radius: 25px;\n    text-decoration: none;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow:\n        0 0 35px rgba(255, 215, 0, 0.5),\n        inset 0 2px 8px rgba(255, 255, 255, 0.3);\n    animation:\n        elegant-wave 5s ease-in-out infinite,\n        wave-glow 2.5s ease-in-out infinite alternate;\n    text-shadow: 0 1px 1px rgba(255,255,255,0.3);\n}\n\n/* Registration form specific button styling */\n.form-actions .btn-cta,\nbutton[type=\"submit\"].btn-cta {\n    color: white !important;\n}\n\n.btn-cta:hover, .btn-demo:hover {\n    background-size: 300% 100%, 300% 100%, 100% 100%;\n    transform: translateY(-3px) scale(1.05);\n    box-shadow:\n        0 0 50px rgba(255, 215, 0, 0.7),\n        inset 0 2px 8px rgba(255, 255, 255, 0.4);\n    color: white !important;\n}\n\n@keyframes pulse {\n    0%, 100% {\n        box-shadow: 0 4px 15px rgba(255, 107, 53, 0.4);\n        transform: translateY(0);\n    }\n    50% {\n        box-shadow: 0 4px 30px rgba(255, 107, 53, 0.6);\n        transform: translateY(-2px);\n    }\n}\n\n.btn-secondary {\n    background-color: transparent !important;\n    color: #000042 !important;\n    border-color: #000042 !important;\n}\n\n.btn-secondary:hover {\n    background-color: #000042 !important;\n    color: white !important;\n    border-color: #000042 !important;\n}\n\n.btn-outline {\n    background-color: transparent;\n    color: #000042;\n    border-color: #000042;\n}\n\n.btn-outline:hover {\n    background-color: #000042;\n    color: white;\n}\n\n/* White border for outline buttons on dark backgrounds */\n.btn-outline[style*=\"color: white\"] {\n    border-color: white !important;\n    color: white !important;\n}\n\n.btn-outline[style*=\"color: white\"]:hover {\n    background-color: white !important;\n    color: #000042 !important;\n    border-color: white !important;\n}\n\n/* Header */\n.header {\n    background-color: white;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 1000;\n    transition: all 0.3s ease;\n}\n\n.header .container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 20px;\n}\n\n.nav-brand .logo {\n    color: #000042;\n    font-size: 1.8rem;\n    margin-bottom: 0;\n    font-family: Georgia, serif;\n}\n\n.nav-brand .tagline {\n    color: #666;\n    font-size: 0.9rem;\n    margin-bottom: 0;\n    font-style: italic;\n}\n\n.nav-menu ul {\n    display: flex;\n    list-style: none;\n    align-items: center;\n    gap: 30px;\n}\n\n.nav-menu a {\n    text-decoration: none;\n    color: #333;\n    font-weight: 500;\n    transition: color 0.3s ease;\n}\n\n.nav-menu a:hover {\n    color: #000042;\n}\n\n/* Hero Section */\n.hero {\n    background: #000042;\n    color: white;\n    padding: 120px 0 80px;\n    margin-top: 80px;\n}\n\n.hero-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 60px;\n    align-items: center;\n}\n\n.hero-title {\n    font-size: 3rem;\n    margin-bottom: 20px;\n    color: white;\n}\n\n.hero-subtitle {\n    font-size: 1.3rem;\n    margin-bottom: 30px;\n    opacity: 0.9;\n    line-height: 1.6;\n}\n\n.hero-stats {\n    display: flex;\n    gap: 40px;\n    margin-bottom: 40px;\n    padding: 20px 0;\n    border-top: 1px solid rgba(255,255,255,0.2);\n    border-bottom: 1px solid rgba(255,255,255,0.2);\n}\n\n.stat-item {\n    text-align: center;\n}\n\n.stat-number {\n    display: block;\n    font-size: 2.5rem;\n    font-weight: bold;\n    color: #fff;\n    font-family: Georgia, serif;\n}\n\n.stat-label {\n    display: block;\n    font-size: 0.9rem;\n    opacity: 0.8;\n    margin-top: 5px;\n}\n\n/* Trust Section */\n.trust-section {\n    background-color: white;\n    padding: 40px 0;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.trust-badges {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 30px;\n}\n\n.badge, .trust-badge {\n    background-color: #f8f9fa;\n    padding: 10px 20px;\n    border-radius: 25px;\n    border: 2px solid #e9ecef;\n    font-weight: 600;\n    color: #666;\n    font-size: 0.9rem;\n}\n\n/* Services Section */\n.services {\n    padding: 80px 0;\n    background-color: white;\n}\n\n.section-header {\n    text-align: center;\n    margin-bottom: 60px;\n}\n\n.section-title {\n    color: #000042;\n    margin-bottom: 15px;\n}\n\n.section-subtitle {\n    color: #666;\n    font-size: 1.2rem;\n    max-width: 600px;\n    margin: 0 auto;\n}\n\n.services-grid, .grid {\n    display: grid;\n    gap: 30px;\n}\n\n.grid-cols-2 { grid-template-columns: repeat(2, 1fr); }\n.grid-cols-3 { grid-template-columns: repeat(3, 1fr); }\n.grid-cols-4 { grid-template-columns: repeat(4, 1fr); }\n\n.service-card, .card {\n    background-color: #f8f9fa;\n    padding: 40px 30px;\n    border-radius: 25px;\n    border: 1px solid #e9ecef;\n    transition: all 0.3s ease;\n}\n\n.service-card:hover, .card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n    border-color: #000042;\n}\n\n.service-icon {\n    font-size: 3rem;\n    margin-bottom: 20px;\n}\n\n.service-card h4, .card h4 {\n    color: #000042;\n    margin-bottom: 15px;\n}\n\n.service-card p, .card p {\n    color: #666;\n    margin-bottom: 20px;\n}\n\n.service-features {\n    list-style: none;\n    text-align: left;\n}\n\n.service-features li {\n    padding: 8px 0;\n    color: #555;\n    position: relative;\n    padding-left: 20px;\n}\n\n.service-features li:before {\n    content: \"✓\";\n    position: absolute;\n    left: 0;\n    color: #000042;\n    font-weight: bold;\n}\n\n/* Features Section */\n.features {\n    padding: 80px 0;\n    background-color: #f8f9fa;\n}\n\n.features-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 40px;\n}\n\n.feature-item {\n    background-color: white;\n    padding: 40px 30px;\n    border-radius: 25px;\n    text-align: center;\n    border: 1px solid #e9ecef;\n    transition: all 0.3s ease;\n}\n\n.feature-item:hover {\n    box-shadow: 0 8px 20px rgba(0,0,0,0.1);\n    transform: translateY(-3px);\n}\n\n.feature-icon {\n    font-size: 3rem;\n    margin-bottom: 20px;\n}\n\n.feature-item h4 {\n    color: #000042;\n    margin-bottom: 15px;\n}\n\n.feature-item p {\n    color: #666;\n}\n\n/* Pricing Section */\n.pricing {\n    padding: 80px 0;\n    background-color: white;\n}\n\n.pricing-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 30px;\n    margin-top: 50px;\n}\n\n.pricing-card {\n    background-color: #f8f9fa;\n    border: 2px solid #e9ecef;\n    border-radius: 25px;\n    padding: 40px 30px;\n    text-align: center;\n    position: relative;\n    transition: all 0.3s ease;\n}\n\n.pricing-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n}\n\n.pricing-card.featured {\n    border-color: #000042;\n    background-color: white;\n    transform: scale(1.05);\n}\n\n.popular-badge {\n    position: absolute;\n    top: -15px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #000042;\n    color: white;\n    padding: 8px 20px;\n    border-radius: 25px;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.price {\n    font-size: 3rem;\n    font-weight: bold;\n    color: #000042;\n    font-family: Georgia, serif;\n}\n\n.period {\n    font-size: 1.2rem;\n    color: #666;\n}\n\n/* Forms */\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 600;\n    color: #333;\n}\n\n.form-control, input[type=\"text\"], input[type=\"email\"], input[type=\"tel\"],\ninput[type=\"password\"], input[type=\"number\"], textarea, select {\n    width: 100%;\n    padding: 12px;\n    border: 2px solid #e9ecef;\n    border-radius: 25px;\n    font-size: 16px;\n    color: #000000;\n    transition: border-color 0.3s ease;\n}\n\n.form-control:focus, input:focus, textarea:focus, select:focus {\n    outline: none;\n    border-color: #000042;\n}\n\n/* Footer */\n.footer {\n    background-color: #000042;\n    color: white;\n    padding: 60px 0 20px;\n}\n\n.footer-content {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;\n    gap: 40px;\n    margin-bottom: 40px;\n}\n\n.footer-brand h4 {\n    color: white;\n    margin-bottom: 15px;\n}\n\n.footer-brand p {\n    opacity: 0.8;\n    line-height: 1.6;\n}\n\n.footer-section h5 {\n    color: white;\n    margin-bottom: 20px;\n    font-size: 1.1rem;\n}\n\n.footer-section ul {\n    list-style: none;\n}\n\n.footer-section li {\n    margin-bottom: 10px;\n}\n\n.footer-section a {\n    color: rgba(255,255,255,0.8);\n    text-decoration: none;\n    transition: color 0.3s ease;\n}\n\n.footer-section a:hover {\n    color: white;\n}\n\n/* Lithuanian Text Fixes */\n.lithuanian-heading {\n    font-family: Georgia, serif;\n    color: #000042;\n    letter-spacing: -0.5px;\n}\n\n.lithuanian-text {\n    line-height: 1.7;\n    color: #333;\n}\n\n/* Admin Dashboard */\n.admin-header {\n    background: #000042;\n    color: white;\n    padding: 2rem 0;\n}\n\n.dashboard-card {\n    background: white;\n    border-radius: 25px;\n    padding: 2rem;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n    margin-bottom: 2rem;\n}\n\n.stat-card {\n    background: #000042;\n    color: white;\n    padding: 2rem;\n    border-radius: 25px;\n    text-align: center;\n}\n\n/* Utility Classes */\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.mt-1 { margin-top: 0.5rem; }\n.mt-2 { margin-top: 1rem; }\n.mt-3 { margin-top: 2rem; }\n.mt-4 { margin-top: 3rem; }\n\n.mb-1 { margin-bottom: 0.5rem; }\n.mb-2 { margin-bottom: 1rem; }\n.mb-3 { margin-bottom: 2rem; }\n.mb-4 { margin-bottom: 3rem; }\n\n.p-1 { padding: 0.5rem; }\n.p-2 { padding: 1rem; }\n.p-3 { padding: 2rem; }\n.p-4 { padding: 3rem; }\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .container {\n        padding: 0 15px;\n    }\n\n    .header .container {\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .mobile-menu-toggle {\n        display: block !important;\n    }\n\n    .nav-menu {\n        display: none;\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: 100%;\n        background: white;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n        z-index: 1000;\n    }\n\n    .nav-menu-open {\n        display: block !important;\n    }\n\n    .nav-menu ul {\n        flex-direction: column;\n        padding: 1rem 0;\n        margin: 0;\n        gap: 0;\n    }\n\n    .nav-menu li {\n        width: 100%;\n        text-align: center;\n        border-bottom: 1px solid #f0f0f0;\n    }\n\n    .nav-menu li:last-child {\n        border-bottom: none;\n    }\n\n    .nav-menu a {\n        display: block;\n        padding: 1rem;\n        width: 100%;\n        text-decoration: none;\n        transition: background-color 0.3s ease;\n    }\n\n    .nav-menu a:hover {\n        background-color: #f8f9fa;\n    }\n\n    .nav-menu .btn-secondary,\n    .nav-menu .btn-primary {\n        margin: 0.5rem 1rem;\n        border-radius: 25px;\n        font-weight: 600;\n    }\n\n    .nav-menu .btn-secondary {\n        background: #f8f9fa;\n        color: #000042;\n        border: 2px solid #000042;\n    }\n\n    .nav-menu .btn-primary {\n        background: #000042;\n        color: white;\n        border: 2px solid #000042;\n    }\n\n    .hero-content {\n        grid-template-columns: 1fr;\n        gap: 40px;\n        text-align: center;\n    }\n\n    .hero-title {\n        font-size: 2.2rem;\n    }\n\n    .grid-cols-2, .grid-cols-3, .grid-cols-4 {\n        grid-template-columns: 1fr;\n    }\n\n    .footer-content {\n        grid-template-columns: 1fr;\n        gap: 30px;\n        text-align: center;\n    }\n\n    .btn-cta, .btn-demo {\n        width: 100%;\n        padding: 16px;\n    }\n}\n\n/* Loading States */\n.loading {\n    opacity: 0.7;\n    pointer-events: none;\n}\n\n.spinner {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    border: 3px solid #e9ecef;\n    border-top-color: #000042;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n/* Smooth scrolling */\nhtml {\n    scroll-behavior: smooth;\n}\n\n\n@keyframes elegant-wave {\n  0% { background-position: 0% 50%, 100% 50%, 0% 50%; }\n  50% { background-position: 100% 50%, 0% 50%, 0% 50%; }\n  100% { background-position: 0% 50%, 100% 50%, 0% 50%; }\n}\n\n@keyframes wave-glow {\n  0% { box-shadow: 0 0 35px rgba(255, 215, 0, 0.5), inset 0 2px 8px rgba(255, 255, 255, 0.3); }\n  100% { box-shadow: 0 0 50px rgba(255, 215, 0, 0.7), inset 0 2px 8px rgba(255, 255, 255, 0.4); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
